@if (deliveryNote(); as dn) {
  <soft-ds-card [chevron]="true">
    <soft-ds-card-header>
      <soft-ds-card-leading>
        <soft-ds-card-title>LS {{ dn.belegnummer }}</soft-ds-card-title>
        <soft-ds-badge variant="outline" class="ml-2">
          {{ dn.adresseBean?.kurzbez || '-' }}
        </soft-ds-badge>
      </soft-ds-card-leading>
      <soft-ds-card-trailing>
        <span class="ml-auto text-light text-sm">
          {{ dn.lieferdatum | date }}
        </span>
      </soft-ds-card-trailing>
    </soft-ds-card-header>

    <soft-ds-card-body>
      <div class="flex flex-col gap-2 flex-1">
        <div class="flex gap-1 flex-wrap text-light text-sm">
          <soft-chip
            color="surface"
            icon="fa-regular fa-user"
            [customClass]="'text-light'"
          >
            {{ dn.adresseBean?.vorname }}
            {{ dn.adresseBean?.nachname }}
          </soft-chip>
          @if (dn.vkftour?.bezeichnung) {
            <soft-chip
              color="surface"
              icon="fa-regular fa-truck"
              [customClass]="'text-light'"
            >
              {{ dn.vkftour?.bezeichnung }}
            </soft-chip>
          }
          @if (dn.paletten && dn.paletten.length > 0) {
            <soft-chip
              color="surface"
              icon="fa-regular fa-layer-group"
              [customClass]="'text-light'"
            >
              {{ dn.paletten.length }} Paletten
            </soft-chip>
          }
        </div>
        @if (dn.paletten && dn.paletten.length > 0) {
          <div class="flex justify-between items-center gap-3">
            <soft-ds-progress-bar
              [value]="progressBarValue()"
              [severity]="
                dn.palettenModus === PalettenModus.Erledigt ? 'success' : 'warning'
              "
            />
            <span
              class="text-sm"
              [class]="
                dn.palettenModus === PalettenModus.Erledigt
                  ? 'text-success-600'
                  : 'text-warning-600'
              "
            >
              {{ numOfErledigtPaletten() }}/{{ dn.paletten.length }}
            </span>
          </div>
          <div class="flex gap-1 flex-wrap">
            @for (
              p of dn.paletten.slice(0, PALETTEN_LIMIT);
              track p.id;
              let idx = $index
            ) {
              <soft-ds-badge
                [variant]="
                  p.auslieferungsstatus === palettenModus() ? 'success' : 'outline'
                "
                [size]="'lg'"
              >
                P{{ idx + 1 }}
              </soft-ds-badge>
            }
            @if (dn.paletten.length > PALETTEN_LIMIT) {
              <soft-ds-badge variant="outline" [size]="'lg'">
                +{{ dn.paletten.length - PALETTEN_LIMIT }}
              </soft-ds-badge>
            }
          </div>
        }
      </div>
    </soft-ds-card-body>
  </soft-ds-card>
}

<!-- @if (deliveryNote) {
  <div
    class="soft-card rounded-m p-3 flex flex-col mb-2"
    [class.barverkauf]="deliveryNote?.type?.type === 'BARVERKAUF'"
    [class.kreditrechnung]="deliveryNote?.type?.type === 'KREDITRECHNUNG'"
  >
    <div class="flex flex-1 items-center justify-between w-full">
      <div class="flex flex-col w-full">
        <span class="soft-overline">
          {{ deliveryNote?.belegnummer }}
          @if (deliveryNote.type?.bezeichnung) {
            ({{ deliveryNote.type?.bezeichnung }})
          }
          @if (deliveryNote?.vkftour?.vkftour && deliveryNote?.vkftour?.bezeichnung) {
            - {{ deliveryNote?.vkftour?.vkftour }} /
            {{ deliveryNote?.vkftour?.bezeichnung }} ({{
              deliveryNote?.vkftour?.tourfolge
            }})
          }
        </span>
        <div class="mb-1 flex items-center">
          <span style="font-weight: 700">
            {{ deliveryNote?.adresseBean?.kurzbez || '-' }}
          </span>
          @if (deliveryNote | deliveryNoteChanged | async) {
            <div [style]="{ 'min-width': '1rem' }" class="ml-4">
              <soft-chip class="bg-accent-500 text-xs">GEÄNDERT</soft-chip>
            </div>
          }
        </div>
        <span class="text-sm color-light">
          {{ deliveryNote?.adresseBean?.plz }}&nbsp;{{ deliveryNote?.adresseBean?.ort }}
        </span>
        @if (deliveryNote | deliveryNoteChanged | async) {
          <div [style]="{ 'min-width': '1rem' }" class="ml-4">
            <soft-chip class="bg-accent-500 text-xs">GEÄNDERT</soft-chip>
          </div>
        }
      </div>
      <div class="flex items-center justify-end p-1 min-w-fit relative">
        <span class="opacity-50 text-sm font-medium min-w-full">
          {{ deliveryNote?.lieferzeit }} Uhr
        </span>
        <i class="fa-regular fa-chevron-right opacity-[15%] text-xl"></i>
      </div>
    </div>
  </div>
} -->
